import i18n from "./i18n";

require('./bootstrap');

window.Vue = require('vue').default;
import Vuetify from 'vuetify';
import router from "./public-router";
import store from "./public/store/store";
import {registerFroala} from './froala/registerFroala';
import PublicSection from "./components/Public/PublicSection.vue";
import PublicBase from "./components/Public/PublicBase.vue";
import PublicTest from "./components/Test/PublicTest.vue";
import TestPass from "./components/Test/TestPass.vue";

Vue.component('public-section', PublicSection);
Vue.component('public-base', PublicBase);
Vue.component('public-test', PublicTest);
Vue.component('public-test-pass', TestPass);
Vue.use(Vuetify);
registerFroala(Vue);

const app = new Vue({
    vuetify: new Vuetify(
        {
            lang: {
                current: 'ru',
            },
            theme: {},
        }
    ),
    el: '#app',
    i18n,
    router,
    store
});

